// Feature flags (build-time). Set REACT_APP_FOUNDERS_ENABLED=true and redeploy
// once your Stripe account is claimed to expose the Founder / Buy CTAs.
export const FOUNDERS_ENABLED = process.env.REACT_APP_FOUNDERS_ENABLED === "true";
